import { c as _c } from "react/compiler-runtime";
import { PencilIcon, TrashIcon } from '@heroicons/react/24/solid';
import { useState } from 'react';
import type { ClientUploadedFileData } from 'uploadthing/types';
import { cn } from '@/frontend/utils';
import { Field } from '../../forms/Fieldset';
import { Input } from '../../forms/Input';
import { Dialog, DialogActions } from '../../overlays/Dialog';
import { Label3 } from '../../typography/Label';
import { P2 } from '../../typography/Paragraph';
import { Button } from '../Button';
export function ManageAttachment(t0) {
  const $ = _c(33);
  const {
    file,
    files,
    setFiles,
    disabled: t1,
    className
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  let t2;
  if ($[0] !== file.key || $[1] !== files || $[2] !== setFiles) {
    t2 = newName => {
      setFiles(files.map(f => f.key === file.key ? {
        ...f,
        name: newName
      } : f));
    };
    $[0] = file.key;
    $[1] = files;
    $[2] = setFiles;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleRename = t2;
  let t3;
  if ($[4] !== className) {
    t3 = cn("flex flex-row justify-between rounded-md bg-backgroundTertiary px-2 py-1", className);
    $[4] = className;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== file.name) {
    t4 = <Label3>{file.name}</Label3>;
    $[6] = file.name;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setIsDialogOpen(true);
    t6 = <PencilIcon className="size-3" />;
    $[8] = t5;
    $[9] = t6;
  } else {
    t5 = $[8];
    t6 = $[9];
  }
  let t7;
  if ($[10] !== disabled) {
    t7 = <Button outline={true} size="xs" className="px-2! py-0.5!" disabled={disabled} onClick={t5}>{t6} Zmień nazwę</Button>;
    $[10] = disabled;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== file.key || $[13] !== files || $[14] !== setFiles) {
    t8 = () => setFiles(files.filter(f_0 => f_0.key !== file.key));
    $[12] = file.key;
    $[13] = files;
    $[14] = setFiles;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <TrashIcon className="size-3" />;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== disabled || $[18] !== t8) {
    t10 = <Button plain={true} size="xs" disabled={disabled} className="px-2! py-0.5!" onClick={t8}>{t9}</Button>;
    $[17] = disabled;
    $[18] = t8;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t7) {
    t11 = <div className="flex flex-row items-center gap-3">{t7}{t10}</div>;
    $[20] = t10;
    $[21] = t7;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = () => setIsDialogOpen(false);
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== file.name || $[25] !== handleRename || $[26] !== isDialogOpen) {
    t13 = <RenameAttachmentDialog initialName={file.name} open={isDialogOpen} onClose={t12} onSave={handleRename} />;
    $[24] = file.name;
    $[25] = handleRename;
    $[26] = isDialogOpen;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t11 || $[29] !== t13 || $[30] !== t3 || $[31] !== t4) {
    t14 = <div className={t3}>{t4}{t11}{t13}</div>;
    $[28] = t11;
    $[29] = t13;
    $[30] = t3;
    $[31] = t4;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  return t14;
}
function RenameAttachmentDialog(t0) {
  const $ = _c(24);
  const {
    initialName,
    open,
    onClose,
    onSave
  } = t0;
  const [newName, setNewName] = useState(initialName);
  let t1;
  if ($[0] !== newName || $[1] !== onClose || $[2] !== onSave) {
    t1 = () => {
      onSave(newName);
      onClose();
    };
    $[0] = newName;
    $[1] = onClose;
    $[2] = onSave;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleSave = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <P2>Zmień nazwę załącznika</P2>;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Label3>Nazwa załącznika</Label3>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = e => setNewName(e.target.value);
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== newName) {
    t5 = <Field>{t3}<Input value={newName} onChange={t4} /></Field>;
    $[7] = newName;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== onClose) {
    t6 = <Button outline={true} onClick={onClose}>Anuluj</Button>;
    $[9] = onClose;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== newName) {
    t7 = newName.trim();
    $[11] = newName;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const t8 = !t7;
  let t9;
  if ($[13] !== handleSave || $[14] !== t8) {
    t9 = <Button onClick={handleSave} disabled={t8}>Zapisz</Button>;
    $[13] = handleSave;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t6 || $[17] !== t9) {
    t10 = <DialogActions>{t6}{t9}</DialogActions>;
    $[16] = t6;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== onClose || $[20] !== open || $[21] !== t10 || $[22] !== t5) {
    t11 = <Dialog open={open} onClose={onClose} className="space-y-4">{t2}{t5}{t10}</Dialog>;
    $[19] = onClose;
    $[20] = open;
    $[21] = t10;
    $[22] = t5;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  return t11;
}